import { motion } from "framer-motion";
import { User, Repeat } from "lucide-react";
import { STATUS_META } from "@/lib/status";

export default function FlatCard({ flat, onClick }) {
  const meta = STATUS_META[flat.effective_status] || STATUS_META.vacant;
  return (
    <motion.button
      whileHover={{ y: -2 }}
      onClick={onClick}
      data-testid={`flat-card-${flat.id}`}
      className="text-left rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm hover:shadow-md hover:border-slate-300 transition-shadow w-full"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-display text-lg font-bold text-slate-900">{flat.flat_number}</p>
          <p className="text-[11px] uppercase font-mono tracking-[0.14em] text-slate-400">{flat.bhk_type}</p>
        </div>
        <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${meta.badge}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} /> {meta.label}
        </span>
      </div>
      <div className="mt-3 flex items-center gap-1.5 text-sm text-slate-600">
        <User className="h-3.5 w-3.5 text-slate-400" />
        <span className="truncate">{flat.owner_name}</span>
      </div>
      <div className="mt-2 flex items-center justify-between">
        <span className="text-xs text-slate-400">{flat.furnishing_status}</span>
        <span className="inline-flex items-center gap-1 text-xs font-mono text-slate-500" title="Times rented out">
          <Repeat className="h-3 w-3" /> {flat.times_rented}×
        </span>
      </div>
    </motion.button>
  );
}
